import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            title:'',
            seq:'',
            type:'',
            time:'',
            price:'',
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('상품명을 입력해주세요.')
        },
        seq: function (value) {
            return Validator.value(value)
                .required('노출 순서를 입력해주세요.')
        },
        type: function (value) {
            return Validator.value(value)
                .required('기간에 대해 선택해주세요.')
        },
        time: function (value) {
            return Validator.value(value)
                .required('기간을 입력해주세요.')
        },
        price: function (value) {
            return Validator.value(value)
                .required('가격을 입력해주세요.')
        },
    },
}
